// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__149jL","addWidgetButton":"Header_addWidgetButton__3eSJ6","dashboardTabs":"Header_dashboardTabs__3GI23","active":"Header_active__2uj4x"};